import TUIChat from "./TUIChat";
import TUIConversation from "./TUIConversation";
import TUIProfile from "./TUIProfile";
import TUISearch from "./TUISearch";
import TUIContact from "./TUIContact";

const TUIComponents = {
  TUIChat,
  TUIConversation,
  TUIProfile,
  TUIContact,
  TUISearch,
};

export default TUIComponents;

export {
  TUIChat,
  TUIConversation,
  TUIProfile,
  TUIContact,
  TUISearch,
};
